import { useState } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"

/**
 * useCancelTransferApplicationフックの戻り値の型定義
 */
interface UseCancelTransferApplicationReturn {
  /** 立替送金申請をキャンセルする関数 */
  cancelTransferApplication: (id: number) => Promise<void>
  /** キャンセル処理中かどうか */
  isCanceling: boolean
  /** キャンセル処理でのエラー */
  error: Error | null
  /** エラーをリセットする関数 */
  resetError: () => void
}

/**
 * 立替送金申請をキャンセルするためのカスタムフック
 *
 * @returns キャンセル機能とその状態
 */
export const useCancelTransferApplication = (): UseCancelTransferApplicationReturn => {
  const { patchWithToken } = useSmoothApi()
  const [isCanceling, setIsCanceling] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  /**
   * エラーをリセットする関数
   */
  const resetError = () => {
    setError(null)
  }

  /**
   * 立替送金申請をキャンセルする
   * @param id - 申請ID
   */
  const cancelTransferApplication = async (id: number): Promise<void> => {
    setIsCanceling(true)
    setError(null)

    try {
      const url = `${SMOOTH_LINE_API_URL}/base_api/smoother/screen/transfer_applications/${id}/cancel`
      await patchWithToken(url)
    } catch (err) {
      const error = err instanceof Error ? err : new Error("立替送金申請のキャンセルに失敗しました")
      console.error("立替送金申請のキャンセルに失敗しました:", err)
      setError(error)
      throw error
    } finally {
      setIsCanceling(false)
    }
  }

  return {
    cancelTransferApplication,
    isCanceling,
    error,
    resetError,
  }
}
